/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:34:25+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T16:56:22+08:00
 */
 import { Approval } from '../constants/approval-constants.js';

 const initState = {
     
 }

 export default function approval (state = initState, action) {
   switch (action.type) {
      // employee home
      case Approval.ActionTypes.FETCHOVERTIMELISTSSUCCESS:
          return {...state, ...action.payload};
      default:
          return {...state};
   }
 }



// WEBPACK FOOTER //
// ./src/reducers/approval-reducer.js